import { CombinedError } from '@urql/core';
import i18n from 'i18next';
import { toast } from 'sonner';

const PARTIAL_DATA_TOAST_ID = 'partial-data';

export function showErrorToast(error: unknown): void {
  const message = resolveErrorMessage(error);
  toast.error(message, { duration: Infinity });
}

export function resolveErrorMessage(error: unknown): string {
  const t = i18n.t.bind(i18n);

  if (error instanceof CombinedError) {
    if (error.networkError) {
      return t('errors.NETWORK_ERROR');
    }

    const gqlError = error.graphQLErrors[0];
    if (gqlError) {
      const code = gqlError.extensions?.code as string | undefined;
      if (code) {
        const key = `errors.${code}`;
        const translated = t(key, { defaultValue: '' });
        if (translated) return translated;
      }
      if (gqlError.message) {
        return gqlError.message;
      }
    }
  }

  return t('errors.UNKNOWN_ERROR');
}

export function showPartialDataToast(error: unknown): void {
  toast.warning(i18n.t('errors.PARTIAL_DATA'), {
    id: PARTIAL_DATA_TOAST_ID,
    description: resolveErrorMessage(error),
  });
}
